import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, X } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/store";

const DISMISS_KEY = "ps_voucher_banner_dismissed";

const todayISO = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };
export const daysLeft = (date) => Math.round((Date.parse(date) - Date.parse(todayISO())) / 86400000);
export const isExpiringSoon = (v) => v.balance > 0 && daysLeft(v.expires_at) >= 0 && daysLeft(v.expires_at) <= 30;

export const ExpiringVoucherBanner = () => {
  const { user } = useAuth();
  const [soon, setSoon] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    if (!user) return setSoon(null);
    api.get("/vouchers/mine").then(({ data }) => {
      const list = data.filter(isExpiringSoon).sort((a, b) => a.expires_at.localeCompare(b.expires_at));
      setSoon(list[0] || null);
    }).catch(() => {});
  }, [user]);

  if (!soon || hidden) return null;
  const d = daysLeft(soon.expires_at);

  return (
    <div data-testid="voucher-expiry-banner" className="bg-[#0f2a1d] border-b border-emerald-500/30 text-emerald-200 text-xs">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3">
        <Ticket size={14} className="text-emerald-400 shrink-0" />
        <span>
          Il tuo buono <span className="font-mono-ps text-emerald-400">{soon.code}</span> da € {soon.balance.toFixed(2)} scade{" "}
          {d === 0 ? "oggi" : d === 1 ? "domani" : `tra ${d} giorni`}.{" "}
          <Link to="/account?tab=vouchers" data-testid="voucher-expiry-banner-link" className="underline underline-offset-2 text-white">Usalo ora</Link>
        </span>
        <button
          data-testid="voucher-expiry-banner-close"
          onClick={() => { sessionStorage.setItem(DISMISS_KEY, "1"); setHidden(true); }}
          className="text-emerald-300/70 hover:text-white"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};
